"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shapes = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const Shapes_styles_1 = require("./Shapes.styles");
const THUMBNAIL_SIZE = 58;
function Shapes({ options, onUpdate, onSectionClose, handleShapes, }) {
    const mediumShapeSvgSize = 300;
    const [type, setType] = (0, react_1.useState)(options[0].value);
    const [shapesData, setShapesData] = (0, react_1.useState)([]);
    const [size, setSize] = (0, react_1.useState)(mediumShapeSvgSize);
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const formattedShapeOptions = options.map((option) => ({
        value: option.value,
        label: t(option.titleKey),
        isSelected: type === option.value, // set default isSelected value
    }));
    const theme = (0, ui_common_components_1.useTheme)();
    const getViewBox = (0, react_1.useCallback)((size) => {
        const offset = size * 0.05;
        return `${-offset}, ${-offset}, ${size + offset * 2}, ${size + offset * 2}`;
    }, []);
    (0, react_1.useEffect)(function firstCategoryLoader() {
        changeHandler(type);
    }, []);
    const changeHandler = (0, react_1.useCallback)((type) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        setType(type);
        setShapesData([]);
        const { data, size } = yield handleShapes(type);
        setSize(size);
        setShapesData(data);
    }), [handleShapes]);
    const ShapesSkeletonGrid = (0, react_1.useCallback)(() => ((0, jsx_runtime_1.jsx)(Shapes_styles_1.StyledShapesSkeleton, { children: Array.from({ length: 32 }, (_, i) => ((0, jsx_runtime_1.jsx)(antd_1.Skeleton.Avatar, { active: true, shape: "square", size: "large", style: {
                height: ui_common_components_1.utils.rem(THUMBNAIL_SIZE),
                width: ui_common_components_1.utils.rem(THUMBNAIL_SIZE),
            } }, i))) })), []);
    const handleClick = (0, react_1.useCallback)((event) => {
        const target = event.target;
        const svg = target.closest('svg');
        const path = svg === null || svg === void 0 ? void 0 : svg.querySelector('path');
        if (!path || path.tagName !== 'path') {
            return;
        }
        const { width, height } = path.getBBox();
        const value = path.getAttribute('d');
        const size = {
            width,
            height,
        };
        onUpdate({ value, size: size });
        onSectionClose(false);
    }, [onSectionClose, onUpdate]);
    return ((0, jsx_runtime_1.jsxs)(Shapes_styles_1.StyledContainer, { children: [(0, jsx_runtime_1.jsx)(Shapes_styles_1.StyledSelectContainer, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Select, { options: formattedShapeOptions, onChange: (type) => {
                        changeHandler(type);
                    } }) }), (0, jsx_runtime_1.jsx)(Shapes_styles_1.StyledShapesContainer, { children: shapesData.length > 0 ? (shapesData.map((shape) => ((0, jsx_runtime_1.jsx)(Shapes_styles_1.StyledSvg, { width: THUMBNAIL_SIZE, height: THUMBNAIL_SIZE, viewBox: getViewBox(size), fill: theme.Color.Neutrals.Border, onClick: handleClick, children: (0, jsx_runtime_1.jsx)("path", { d: shape.path }) }, shape.key)))) : ((0, jsx_runtime_1.jsx)(ShapesSkeletonGrid, {})) })] }));
}
exports.Shapes = Shapes;
//# sourceMappingURL=Shapes.js.map